import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NavigationService } from '@core/navigation/navigation.service';
import { AuthLocalService } from '../auth-local.service';
import { IUser } from '@core/models/auth/user';
import { AppAlertService } from '@shared/services/app/alert.service';

@Injectable({
    providedIn: 'root',
})
export class PermisoGuard implements CanActivate {
    constructor(
        private navigationService: NavigationService,
        private authLocalService: AuthLocalService,
        //private alertService: AppAlertService,
        private router: Router
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        // Asegúrate de que los menús se carguen
        await this.navigationService.getMenusX();

        const routePath = state.url;

        if (this.navigationService.hasAccess(routePath)) {
            return true; // Acceso permitido
        } else {
            //this.alertService.warning("No tiene acceso al módulo, redirigiendo a Home");
            /* Invento redirigir de vuelta al acceso directo del usuario */
            let session = this.authLocalService.getCurrentSession();
            let usuario: IUser = session.user;
            let url = usuario.acceso_directo ? usuario.acceso_directo : '/acceso-denegado';
            // Redirigir a una página de acceso denegado o a la página principal
            this.router.navigate([url]);
            return false; // Acceso denegado
        }
    }
}